import { Component, HostListener } from '@angular/core';

@Component({
	selector: 'MyApp',
	templateUrl: 'MyApp.html',
	moduleId: module.id
})
export class AppComponent {

	calcSize() {
		var small = window.innerWidth < 576;
		if (small != this.isSmallScreen) {
			this.isSmallScreen = small;
			if (this.isSmallScreen) {
				this.isOpened = false;
			}
		}
	}
	//https://www.itsolutionstuff.com/post/how-to-get-width-and-height-of-screen-in-angularexample.html
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.calcSize();
	}

	isSmallScreen: boolean = false;

	_isOpened: boolean = true;
	get isOpened(): boolean {
		return this._isOpened;
	}

	set isOpened(value: boolean) {
		if (this._isOpened != value) {
			this._isOpened = value;
			if (!this.isSmallScreen) {
				localStorage.setItem("ePMMenuOpened", value.toString());
			}
		}
	}

	constructor() {
		this.calcSize();
		if (!this.isSmallScreen) {
			var cookie = localStorage.getItem("ePMMenuOpened");
			if (cookie) {
				this._isOpened = this.getBoolean(cookie);
			}
		}
	}

	getBoolean(value: any): boolean {
		if (!value) {
			return false;
		}
		switch (value) {
			case "":
			case "false":
			case "0":
			case 0:
				return false;
			default:
				return true;
		}
	}
}
